module.exports = __webpack_public_path__ + "static/media/plant.dbc2f2d5.webp";